import React, { useEffect, useState } from 'react'

const TOAST_VISIBLE_MS = 2400
const TOAST_FADE_MS = 260

const SearchValidationToast = ({ messages = [], onDismiss }) => {
    const [phase, setPhase] = useState('idle')

    useEffect(() => {
        if (!messages.length) {
            setPhase('idle')
            return undefined
        }

        setPhase('visible')

        const fadeTimeout = window.setTimeout(() => {
            setPhase('fading')
        }, TOAST_VISIBLE_MS)

        const dismissTimeout = window.setTimeout(() => {
            onDismiss?.()
        }, TOAST_VISIBLE_MS + TOAST_FADE_MS)

        return () => {
            window.clearTimeout(fadeTimeout)
            window.clearTimeout(dismissTimeout)
        }
    }, [messages, onDismiss])

    if (!messages.length || phase === 'idle') {
        return null
    }

    return (
        <div className="pointer-events-none absolute left-0 right-0 top-full z-[320] pt-2">
            <div
                className={`pointer-events-auto mx-auto flex w-full max-w-[680px] items-start gap-3 rounded-2xl border border-rose-900/70 bg-[#0d1016]/95 px-3 py-3 shadow-[0_18px_45px_rgba(0,0,0,0.52)] backdrop-blur-sm transition-all duration-300 ease-out cursor-pointer select-none ${
                    phase === 'fading' ? 'translate-y-1 opacity-0' : 'translate-y-0 opacity-100'
                }`}
                role="status"
                aria-live="polite"
                onClick={() => onDismiss?.()}
            >
                <div className="min-w-0 flex-1">
                    <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-rose-200/80">
                        Search Validation
                    </div>
                    <div className="mt-1 flex flex-wrap gap-x-2 gap-y-1 text-sm leading-5 text-rose-50">
                        {messages.map((message) => (
                            <span key={message} className="rounded-md border border-rose-900/50 bg-rose-950/55 px-2 py-1">
                                {message}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SearchValidationToast
